<template>
    <main class="produ">
        <div class="content-wrap">
            <v-image :src="data.companyServerPicture" width="1200px" height="360px"></v-image>
            <!-- <img :src="data.companyServerPicture" alt=""> -->
            <div class="context">
                <div class="ident"><span></span><span></span></div>
                <div v-html="data.companyServerContext"></div>
            </div>
        </div>
    </main>
</template>
<style lang="less" scoped>
@red: #e60012;

.produ {
    width: 1200px;
    margin: 0 auto;
    padding-bottom: 10px;

    img {
        width: 1200px;
        height: 360px;
        object-fit: cover;
    }

    .context {
        width: 1000px;
        min-height: 460px;
        background: #EFEFEF;
        position: relative;
        top: -65px;
        left: 100px;
        padding: 68px 55px 75px 50px;
        font-size: 14px;
        font-weight: 400;
        color: #353535;
        text-align: left;

        .ident {
            display: flex;
            position: absolute;
            top: 39px;
            left: 455px;

            span {
                width: 48px;
                height: 4px;
                background-color: #353535;

                &:not(:last-child) {
                    background-color: @red;
                }

            }
        }
    }

}

@media screen and (max-width: 1360px) {
    .produ {
        width: 100%;
        margin: 0 auto;
        padding-bottom: 10px;

        .v-image {
            width: 100% !important;
            height: 48vw !important;
            object-fit: cover;

            /deep/ img {
                width: 100% !important;
                height: 48vw !important;
            }
        }

        .context {
            width: calc(100% - 60px);
            margin: -3vw 30px 0 30px;
            min-height: 360px;
            background: #EFEFEF;
            position: relative;
            top: -65px;
            left: 0;
            padding: 68px 55px 75px 50px;
            font-size: 14px;
            font-weight: 400;
            color: #353535;
            text-align: left;

            .ident {
                display: flex;
                position: absolute;
                top: 39px;
                left: calc(50% - 24px);

                span {
                    width: 48px;
                    height: 4px;
                    background-color: #353535;

                    &:not(:last-child) {
                        background-color: @red;
                    }

                }
            }
        }

    }
}
</style>
<script>
export default {
    data() {
        return {
            data: {}
        }
    },
    computed: {
        id() {
            return this.$route.params.id
        }
    },
    methods: {
        getServiceList() {
            let that = this;
            ajax.call(this, {
                url: "/bloc/companyServer/list/language",
                data: {
                    companyId: that.id
                },
                s(res) {
                    if (res.data) {
                        that.data = res.data
                    } else {
                        that.data = {}
                    }
                }
            });
        },

    },
    mounted() {
        this.getServiceList();
    },
    watch: {
        "$root.language"() {
            this.getServiceList();
        },
        id() {
            this.getServiceList();
        }
    }
}
</script>